import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { PortalProveedorService, SupplierExtendedData } from '../services/api.services';

@Injectable({
  providedIn: 'root'
})
export class PendingSelectOperadorGuard implements CanActivate {

  constructor(private router: Router,
              private portalProveedorService: PortalProveedorService
              ) {}


  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    try {
      let resolveFun: (value?: boolean) => void = null;
      let rejectFun: (reason?: any) => void = null;
      const promiseToReturn = new Promise<boolean>((resolve, reject) => {
        resolveFun = resolve;
        rejectFun = reject;
      });
      const operatorIdSelected = this.portalProveedorService.getOperatorSel();
      if (operatorIdSelected !== undefined && operatorIdSelected !== null) {
        return true;
      }
      this.portalProveedorService.getSupplierDataCached().toPromise().then((supplierExtendedData: SupplierExtendedData) => {
        if (!supplierExtendedData) {
          this.router.navigate(['login'], { replaceUrl: true });
          resolveFun(false);
          return;
        }
        if (supplierExtendedData.supplier.house_supplier_view_permissions.must_select_operator) {
            this.router.navigate(['seleccion-operario']);
            resolveFun(false);
        } else {
          resolveFun(true);
        }
      });
      return promiseToReturn;

    } catch (error) {
      this.portalProveedorService.logger.error(
        '[PendingSelectOperadorGuard] error(Exception) obteniendo si el usuario tiene que seleccionar operador', error);
      this.router.navigate(['login'], { replaceUrl: true });
    }
  }
}
